import {put, takeEvery} from "redux-saga/effects";

let id = 0;
export const SUCCESS_MESSAGE = 'success';
export const ERROR_MESSAGE = 'error';
export const INFO_MESSAGE = 'info';
export const WARNING_MESSAGE = 'warning';
export const WARN_MESSAGE = 'warn';
export const LOADING_MESSAGE = 'loading';


function* addNotification(params) {
  params.notification.id = id++;
  yield put({type: 'ADD_NOTIFICATION', notification: params.notification});
}

export function* watchNotifications() {
  yield takeEvery('SHOW_NOTIFICATION', addNotification)
}
